import { downloadExcelTemplate } from '../services/api';

/** Templates Excel du bucket ``excels-templates`` (GET /files/download?file=…). */
export const STANDARD_IMPORT_TEMPLATE_FILENAME = 'template_import_policies_standard.xlsx';
export const STANDARD_IMPORT_TEMPLATE_S3_PATH =
    `s3://excels-templates/${STANDARD_IMPORT_TEMPLATE_FILENAME}`;

export const CANCELLED_POLICIES_STANDARD_TEMPLATE_FILENAME =
    'template_import_cancelled_policies_standard.xlsx';
export const CANCELLED_POLICIES_STANDARD_TEMPLATE_S3_PATH =
    `s3://excels-templates/${CANCELLED_POLICIES_STANDARD_TEMPLATE_FILENAME}`;

export const MODIFIED_POLICIES_STANDARD_TEMPLATE_FILENAME =
    'template_import_modified_policies_standard.xlsx';
export const MODIFIED_POLICIES_STANDARD_TEMPLATE_S3_PATH =
    `s3://excels-templates/${MODIFIED_POLICIES_STANDARD_TEMPLATE_FILENAME}`;

const XLSX_CONTENT_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Télécharge un template Excel via GET /files/download?file=…
 * @param {string} fileName
 * @returns {Promise<void>}
 */
export const downloadExcelTemplateFile = async (fileName) => {
    const safeName = String(fileName).trim();
    const response = await downloadExcelTemplate(safeName);
    const blob = new Blob([response.data], {
        type: response.headers?.['content-type'] || XLSX_CONTENT_TYPE,
    });
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = safeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};

/** Template Import Standard polices. */
export const downloadStandardImportTemplate = () => (
    downloadExcelTemplateFile(STANDARD_IMPORT_TEMPLATE_FILENAME)
);

/** Template Import Standard polices annulées. */
export const downloadCancelledPoliciesStandardTemplate = () => (
    downloadExcelTemplateFile(CANCELLED_POLICIES_STANDARD_TEMPLATE_FILENAME)
);

/** Template Import Standard polices modifiées. */
export const downloadModifiedPoliciesStandardTemplate = () => (
    downloadExcelTemplateFile(MODIFIED_POLICIES_STANDARD_TEMPLATE_FILENAME)
);
